import { useMemo } from 'react';
import { ListWithStatus, ListWithStatusItem } from 'ui';
import { DividendEventExtendResponse } from 'api';

interface DistributionStageProps {
  item: DividendEventExtendResponse;
}

export const DistributionStage = ({ item }: DistributionStageProps) => {
  const items = useMemo<ListWithStatusItem[]>(() => {
    return [
      {
        title: 'Confirm payments',
        active: item.operation_statuses?.payments ?? false,
      },
      {
        title: 'Confirm DRPs',
        active: item.operation_statuses?.drps ?? false,
        disabled: !item.operation_statuses?.payments,
      },
    ];
  }, [item]);

  return <ListWithStatus items={items} activeTitleLineThrough={true} />;
};
